var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNttData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 856.74 167.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guias"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.26,0A64.9,64.9,0,0,0,92.57,4.11,62.14,62.14,0,0,0,69.89,0C33.11,0,0,33.45,0,79.23c0,49,41.45,88.62,92.57,88.62s92.57-39.67,92.57-88.62C185.14,33.45,152,0,115.26,0ZM92.57,27a36,36,0,0,1,16.55,29.34c.79,8.75-6,16.46-15.12,17.21S76.81,67.82,76,59.07a15.56,15.56,0,0,1,0-2.73A37.61,37.61,0,0,1,92.57,27Zm1.05,119.84C54.52,146.78,22.88,116.38,23,79v-.36c0-35,26-58.75,47.12-57.56A50.65,50.65,0,0,0,54,57.23c0,25.94,27.17,45.82,55.76,35A36.87,36.87,0,0,0,133.3,57.65v-.42A53.79,53.79,0,0,0,117.8,21c20.46-.6,47.12,23.14,47.12,57.56,0,37.7-31.92,68.25-71.3,68.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.22,39.66V57.27h30.65V127.7h18.39V57.27h30.65V39.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.24,39.66H605.35V57.27H656s10.42,2.59,10.69,10.81v6.8H624.71C608.77,71,599.22,95.66,599.22,95.66v6.88c0,18,8,25.16,24.53,25.16h61.3V69.61C685.66,48.05,678.31,39.66,656.24,39.66ZM628,104.22c-3.07,0-6.75-1.76-6.75-8.8S625,86.61,628,86.61h38.62v17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M827.89,39.66H777V57.27h50s10.42,2.59,11.3,10.81v6.8H795.75C779.81,71,770.88,95.66,770.88,95.66v6.88c0,18,8,25.16,24.52,25.16h61.31V69.61C857.32,48.05,850,39.66,827.89,39.66Zm-28.2,64.56c-3.06,0-6.74-1.76-6.74-8.8s3.68-8.81,6.74-8.81h38.63v17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403,39.66V57.27H433.7V127.7h18.39V57.27h30.65V39.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M691.18,39.66V57.27h30.66V127.7h18.39V57.27h30.65V39.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M593.09,96.77V70.59c0-23.2-9.26-30.93-30.25-30.93H507.26v88h56.19C585.68,127.7,593.09,117,593.09,96.77Zm-18.39.89c0,8.7-3,12.43-10.27,12.43H531.79V57.27h32.64c7.25,0,10.27,3.73,10.27,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.9,106.88c-.59-.6-27.45-52.94-30.43-57.7a18.51,18.51,0,0,0-17.31-10.11c-8.35,0-17.9,3.57-17.9,23.2V127.7h18.39V73a47.91,47.91,0,0,0-.6-10.7c0-1.19,0-1.79.6-2.38s1.19,0,1.79,1.19,25.06,50,30.44,57.69a18.5,18.5,0,0,0,17.3,10.12c8.36,0,17.91-3.57,17.91-23.2v-66h-18.4V94.39a49.13,49.13,0,0,0,.6,10.7c0,1.19,0,1.79-.6,2.38A1.14,1.14,0,0,1,290.9,106.88Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNttData);
export default __webpack_public_path__ + "static/media/NTTData.cdc696661ce0302f784a9f4275aec767.svg";
export { ForwardRef as ReactComponent };